import { getTranslation } from '../../../../utils/translation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamation, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import styles from './ConnectionError.module.scss';

const ConnectionError = () => {
    const isTicketSubmitting = useSelector(state => state.betSlip.isTicketSubmitting);

    return (
        <div className={styles.connectionError}>
            <FontAwesomeIcon className={styles.icon} icon={faExclamation} />
            <span className={styles.title}>{getTranslation('socketConnectionIsDown')}</span>
            <span className={styles.description}>{getTranslation('socketConnectionDownHelp')}</span>
            <button
                className={styles.button}
                disabled={isTicketSubmitting}
                onClick={() => window.location.reload()}
            >
                <FontAwesomeIcon icon={faSyncAlt} className={'m-r-4'} />
                {getTranslation('socketConnectionRefreshButton')}
            </button>
        </div>
    );
};

export default ConnectionError;
